module.exports = __webpack_public_path__ + "img/far_day_cyl125_axis45.5da78d4c.jpg";